import {RequestHandler} from "express-serve-static-core";
import {resolve as resolveUrl} from "url";
import {CLIENT_LIBRARY_URL} from "../bridge/const";
import {IUserProfileBase} from "../bridge/define";
import {IAccountServiceClientJsOptions} from "../includes/dts";
import {UserCenter} from "../includes/user-center";

export interface IJsBuildExpressParam extends IAccountServiceClientJsOptions {
	varName: string;
}

export class ClientJsBuilder<IProfile extends IUserProfileBase> {
	constructor(private uc: UserCenter<IProfile>) {
	}
	
	readonly DEFAULT_CLIENT_CONFIG: IAccountServiceClientJsOptions = {
		init: true,
		debug: false,
		useCookie: true,
		https: true,
	};
	
	public express(options: IJsBuildExpressParam): RequestHandler {
		const varName = options.varName || 'clientJavascriptSourceUrl';
		// const opt = Object.assign({}, this.DEFAULT_CLIENT_CONFIG, options);
		return (req, res, next) => {
			res.locals[varName] = this.getUrl(options);
			next();
		};
	}
	
	public getUrl(opt?: IAccountServiceClientJsOptions) {
		const options = Object.assign({}, this.DEFAULT_CLIENT_CONFIG, opt || {});
		const init = options.init? '' : 'no_init=yes&';
		const debug = options.debug? 'iframe_debug=yes&' : '';
		const requestType = 'server_type=' + (options.useCookie? 'cookie' : 'none') + '&';
		const hash = ''; //'hash=' + createHash(config.serverRequestKey);
		
		const project = `project=${encodeURIComponent(this.uc.projectName)}&`;
		
		const url = resolveUrl(this.uc.ucBaseUrl, CLIENT_LIBRARY_URL + `?${init}${debug}${requestType}${hash}${project}`);
		if (this.uc.options.clientUseHttps) {
			return url.replace(/^http:/, 'https:');
		} else {
			return url;
		}
	}
}
